// Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// Plugins
import { NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IConfig, MaskPipe, NgxMaskModule } from "ngx-mask";
import { SelectDropDownModule } from "ngx-select-dropdown";
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { ClipboardModule } from 'ngx-clipboard';

// Aplicacion
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from './app.component';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { LoginComponent } from './components/shared/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { EjemploComponent } from './components/modals/ejemplo/ejemplo.component';
import { SharedModule } from './components/shared/shared.module';
import { ContraseniamodalComponent } from './components/modals/contraseniamodal/contraseniamodal.component';
import { VerifyAccessComponent } from './components/shared/verify-access/verify-access.component';
import { GeneradorllavemodalComponent } from './components/modals/generadorllavemodal/generadorllavemodal.component';
import { VotacionmodalComponent } from './components/modals/votacionmodal/votacionmodal.component';
import { VotacionfullmodalComponent } from './components/modals/votacionfullmodal/votacionfullmodal.component';
import { EmitirvotopreguntamodalComponent } from './components/modals/emitirvotopreguntamodal/emitirvotopreguntamodal.component';
import { ObtenerresultadomodalComponent } from './components/modals/obtenerresultadomodal/obtenerresultadomodal.component';
import { PreguntamodalComponent } from './components/modals/preguntamodal/preguntamodal.component';
import { VotantemodalComponent } from './components/modals/votantemodal/votantemodal.component';
import { OpcionmodalComponent } from './components/modals/opcionmodal/opcionmodal.component';
import { UsuariomodalComponent } from './components/modals/usuariomodal/usuariomodal.component';
import { ErrorComponent } from './components/error/error.component';
import { ResultadosPublicoComponent } from './components/shared/resultados-publico/resultados-publico.component';
import { RecuperarcontraseniamodalComponent } from './components/modals/recuperarcontraseniamodal/recuperarcontraseniamodal.component';
import { BlockCopyPasteDirective } from './directives/block-copy-paste.directive';
import { FragmentarllavemodalComponent } from './components/modals/fragmentarllavemodal/fragmentarllavemodal.component';
import { UnirllavemodalComponent } from './components/modals/unirllavemodal/unirllavemodal.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    VerifyAccessComponent,
    HomeComponent,
    EjemploComponent,
    ContraseniamodalComponent,
    GeneradorllavemodalComponent,
    VotacionmodalComponent,
    VotacionfullmodalComponent,
    EmitirvotopreguntamodalComponent,
    ObtenerresultadomodalComponent,
    PreguntamodalComponent,
    VotantemodalComponent,
    OpcionmodalComponent,
    UsuariomodalComponent,
    ErrorComponent,
    ResultadosPublicoComponent,
    RecuperarcontraseniamodalComponent,
    BlockCopyPasteDirective,
    FragmentarllavemodalComponent,
    UnirllavemodalComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbTypeaheadModule,
    FontAwesomeModule,
    ClipboardModule,
    NgxMaskModule.forRoot(maskConfig),
    SelectDropDownModule,
    AppRoutingModule,
    SharedModule
  ],
  providers: [
    MaskPipe,
    {
      provide: LOCALE_ID,
      useValue: "en"
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}
